import { apiCall, apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";

const apiDockUrl = process.env.REACT_APP_DOCK_API_URL;

export const createCheckListApi = async (data) => {
  return await apiCall("POST", `checklist`, data);
};

export const getEmployeeListApi = async (term) => {
  return await apiCallAdmin("GET", `get_employee?term=${term}`);
};

export const getDeptListApi = async (term) => {
  return await apiCallAdmin("GET", `get_department?term=${term}`);
};

export const getLocListApi = async (term) => {
  return await apiCallAdmin("GET", `get_location?term=${term}`);
};

export const getLocationListApi = async (term) => {
  return await apiCallAdmin("GET", `get_location?term=${term}`);
};

export const createGateApi = async (data) => {
  return await apiCall("POST", `gate`, data);
};

export const createWhatsappTemplateApi = async (data) => {
  return await apiCallAdmin("POST", `whatsapp_template`, data);
};

export const updateWhatsappTemplateApi = async (data, id) => {
  return await apiCallAdmin("PUT", `whatsapp_template/${id}`, data);
};

export const getDeleteWhatsAppTemp = async (id) => {
  return await apiCallAdmin("DELETE", `whatsapp_template/delete/${id}`);
};

export const getWhatsappTemplateDetailsApi = async (id) => {
  const response = await apiCallAdmin("GET", `whatsapp_template/${id}`);
  return response.data;
};

export const getDeleteVehicleType = async (id) => {
  return await apiCall("DELETE", `vehicletype/delete/${id}`);
};

export const getVehicleTypeDetailsApi = async (id) => {
  const response = await apiCall("GET", `vehicletype/get/${id}`);
  return response.data;
};

export const createVehicleTypeApi = async (data) => {
  return await apiCall("POST", `vehicletype`, data);
};

export const updateVehicleTypeApi = async (data, id) => {
  return await apiCall("PUT", `vehicletype/${id}`, data);
};

export const getDeletePOVApi = async (id) => {
  return await apiCall("DELETE", `visit/delete/${id}`);
};

export const getDeleteFieldsApi = async (id) => {
  return await apiCall("DELETE", `register_page/delete/${id}`);
};

export const getPOVDetailsApi = async (id) => {
  const response = await apiCall("GET", `visit/get/${id}`);
  return response.data;
};

export const getProductEditApi = async (id) => {
  const response = await apiCallGeneric("GET", `${apiDockUrl}product_type/${id}`);
  return response.data;
};

export const createProductApi = async (data) => {
  return await apiCallGeneric("POST", `${apiDockUrl}product_type`, data);
};

export const createPOVApi = async (data) => {
  return await apiCall("POST", `visit`, data);
};

export const updatePOVApi = async (data, id) => {
  return await apiCall("PUT", `visit/${id}`, data);
};

export const updateProductApi = async (data, id) => {
  return await apiCallGeneric("PUT", `${apiDockUrl}product_type/${id}`, data);
};

export const getDeleteCheckListApi = async (id) => {
  return await apiCall("DELETE", `checklist/delete/${id}`);
};

export const getDeleteProductListApi = async (id) => {
  return await apiCallGeneric("DELETE", `${apiDockUrl}product_type/${id}`);
};

export const getCheckListDetailsApi = async (id) => {
  const response = await apiCall("GET", `checklist/get/${id}`);
  return response.data;
};

export const updateCheckListApi = async (data, id) => {
  return await apiCall("PUT", `checklist/${id}`, data);
};

export const getDeleteTemplate = async (id) => {
  return await apiCall("DELETE", `email_template/delete/${id}`);
};

export const getDeleteGateTemplate = async (id) => {
  return await apiCall("DELETE", `gatepass_template/delete/${id}`);
};

export const createTemplateApi = async (data) => {
  return await apiCall("POST", `email_template`, data);
};

export const createGateTemplateApi = async (data) => {
  return await apiCall("POST", `gatepass_template`, data);
};

export const updateTemplateApi = async (data, id) => {
  return await apiCall("PUT", `email_template/${id}`, data);
};

export const updateGateTemplateApi = async (data, id) => {
  return await apiCall("PUT", `gatepass_template/${id}`, data);
};

export const getTemplateDetailsApi = async (id) => {
  const response = await apiCall("GET", `email_template/get/${id}`);
  return response.data;
};

//edit gate template
export const getGateTemplateDetailsApi = async (id) => {
  const response = await apiCall("GET", `gatepass_template/get/${id}`);
  return response.data;
};

export const updateAcknowledgement = async (id, data) => {
  return await apiCall("POST", `visitors/acknowledge/${id}`, data);
};

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("GET", `help?application=Gate`);
  return response.data;
};
